import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import ListeaCadetes from "./ListeaCadetes";
import socket from "../tools/socke";

const CadetesBuscador = ({ devuelvo, criterio }) => {
  const [listadoPromocion, setListadoPromocion] = useState([]);
  const [visible, setVisible] = useState(false);
  const [cadetesFiltrados, setCadetesFiltrados] = useState([]);
  const [filtro, setFiltro] = useState("");
  const inputRef = useRef(null);

  // Enfocar el input al montar
  useEffect(() => {
    inputRef.current?.focus();
  }, []);

  // Escuchar cambios por WebSocket
  useEffect(() => {
    socket.on("estadoActdualizable", () => {
      if (filtro) {
        obtieneCadete(filtro);
      }
    });

    return () => {
      socket.off("estadoActdualizable");
    };
  }, [filtro]);

  const capitalizarNombrePropio = (texto) => {
    if (texto === texto.toUpperCase()) {
      // Si está todo en mayúsculas, lo formateamos
      return texto
        .toLowerCase()
        .split(" ")
        .map((p) => p.charAt(0).toUpperCase() + p.slice(1))
        .join(" ");
    }
    // Si ya está con mayúsculas/minúsculas, lo dejamos como está
    return texto;
  };

  // Función para buscar cadetes
  const obtieneCadete = async (dato) => {
    try {
      if (dato.length > 1) {
        const username = process.env.REACT_APP_KEY;
        const password = process.env.REACT_APP_PASS;
        const token = btoa(`${username}:${password}`);

        const response = await axios.post(
          `https://wwwa.isepsantafe.net.ar/expedientes/NCadetes/devuelveCadete/${dato}`,
          { estado: "activo" },
          {
            headers: {
              Authorization: `Basic ${token}`,
            },
          }
        );

        let datos = response.data.datos || [];
// console.log(datos)
        // Capitalizar cada nombre solo si es necesario
        datos = datos.map((cad) => ({
          ...cad,
          cadete: capitalizarNombrePropio(cad.cadete || ""),
        }));

        // Ordenar por primera palabra y luego por segunda palabra del nombre capitalizado
        datos.sort((a, b) => {
          const palabrasA = a.cadete.split(" ");
          const palabrasB = b.cadete.split(" ");

          const primerComparacion = palabrasA[0].localeCompare(palabrasB[0]);
          if (primerComparacion !== 0) {
            return primerComparacion;
          }
          return (palabrasA[1] || "").localeCompare(palabrasB[1] || "");
        });

        setVisible(true);
        setCadetesFiltrados(datos);
      } else {
        setCadetesFiltrados([]);
      }
    } catch (error) {
      console.error("Error en la petición", error);
    }
  };

  // Manejo del input
  const handleInputChange = (e) => {
    const texto = e.target.value;
    setFiltro(texto);
    obtieneCadete(texto);
  };

  // Selección de cadete
  const enciendeLectores = (va) => {
    devuelvo(va);
    setFiltro(""); // limpiar input
    setCadetesFiltrados([]);
    setVisible(false);
  };

  return (
    <div
      style={{
        position: "relative",
        background: "#fff",
        padding: "20px",
        marginBottom: "20px",
        zIndex: 2,
        boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
        borderRadius: "8px",
      }}
    >
      <input
        ref={inputRef}
        type="text"
        placeholder="Ingrese datos"
        value={filtro || ""}
        onChange={handleInputChange}
        style={{
          padding: "12px",
          fontSize: "16px",
          width: "100%",
          borderRadius: "6px",
          border: "1px solid #ccc",
          boxSizing: "border-box",
          textAlign: "center",
          marginBottom: "10px",
        }}
      />

      {visible && cadetesFiltrados.length > 0 && (
        <div
          style={{
            maxHeight: "400px",
            overflowY: "auto",
            borderTop: "1px solid #eee",
            paddingTop: "10px",
          }}
        >
          <ListeaCadetes
            actualiza={(value) => enciendeLectores(value)}
            items={cadetesFiltrados}
          />
        </div>
      )}
    </div>
  );
};

export default CadetesBuscador;
